import Modal from "../../../../../global/Modal";
import useOtherLiensBalanceModal from "../../../hooks/useOtherLiensBalanceModal";

import OtherLiensBalanceForm from "./OtherLiensBalanceForm";

export default function OtherLiensBalanceModal(props) {
  const { mode = "edit", openModal, expenseData } = props;
  const { formValues, isDirty, isSaving, isSaveDisabled, handleFieldOnChange, handleCancel, handleSave } =
    useOtherLiensBalanceModal(props);

  if (mode === "edit" && !expenseData) {
    return null;
  }

  return (
    <Modal open={openModal} onClose={props.handleCloseModal} maxWidth="xs">
      <div>
        <OtherLiensBalanceForm
          title={mode === "add" ? "Add Expense" : "Edit Expense"}
          values={formValues}
          deductionTypeOptions={props.deductionTypeOptions}
          loading={isSaving}
          cancelDisabled={!isDirty}
          saveDisabled={!isDirty || isSaveDisabled}
          onChange={handleFieldOnChange}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>
    </Modal>
  );
}

